import { BASE_URL } from '../API/BASE_URL';

export const sendBrandSupportRegister = async (registrationData, setDisabled) => {
  setDisabled(true);
  const response = await fetch(BASE_URL + 'brand-programm/registration/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json; charset=UTF-8',
    },
    body: JSON.stringify(registrationData),
  });
  const data = await response.json();
  return data;
};
